import { BusinessReportArray } from './BusinessReportGetResponse';

export const EmptyBusinessReportDeleteItem: BusinessReportArray = {
  id: 0,
  date: '',
  projectId: 0,
  projectNo: '',
  projectName: '',
  manHoursCategory: '',
  startTime: '',
  endTime: '',
  manHoursTotal: 0,
};
